import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'approved',
})
export class ApprovedPipe implements PipeTransform {
  transform(value: unknown, user: string): unknown {
    if (Array.isArray(value) && value) {
      const newValue = value.filter(item => {
        return item.status === 'approved' && item.creator.id === user;
      });
      return newValue;
    } else return value;
  }
}
